// src/redux/sessionSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    expired: false,
  },
  reducers: {
    setSessionExpired: (state) => {
      state.expired = true;
    },
    clearSessionExpired: (state) => {
      state.expired = false;
    },
  },
});

export const { setSessionExpired, clearSessionExpired } = sessionSlice.actions;
export default sessionSlice.reducer;

